// Fragment "super_admin validation sweep" — merged by ./index.js.
//
// Empty on purpose: its only key, `pset.domainsRequired`, belonged to the Platform Settings
// editable card, which BUG-166 removed (the page is read-only). Kept as a fragment so ./index.js
// does not change; the next sweep that adds a key here fills it.
export default {
  fr: {},
  en: {},
  es: {},
};
